import React, { useEffect } from "react";

const TableNew = ({
  data,
  scrollToBottom,
  foregroundColor = "#fff",
  backgroundColor = "#000",
  backgroundColorLight,
  metadata,
}) => {
  const {
    header = {},
    content = {},
    border = {},
    headerBackgroundColor = "#ccc",
    rowAlternateColor = true,
    alternateRowColors = [backgroundColor, backgroundColorLight],
    borderRadius = "12px",
  } = metadata;

  console.log("data ::", data);

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    border: `${border?.width || "1px"} solid ${
      border?.color || foregroundColor
    }`,
    borderRadius: borderRadius,
    overflow: "hidden",
    backgroundColor: backgroundColor,
    color: foregroundColor,
  };

  const headerStyle = {
    backgroundColor: headerBackgroundColor,
    color: header?.color || "black",
    fontWeight: header?.fontWeight || "bold",
    fontStyle: header?.fontStyle || "normal",
    fontSize: header?.fontSize || "16px",
    padding: "10px",
    border: `${border.width || "1px"} solid ${border.color || foregroundColor}`,
  };

  const cellStyle = {
    color: content?.color || foregroundColor,
    fontWeight: content?.fontWeight || "normal",
    fontStyle: content?.fontStyle || "normal",
    fontSize: content?.fontSize || "14px",
    padding: "10px",
    borderBottom: `${border.width || "1px"} solid ${
      border.color || foregroundColor
    }`,
  };

  useEffect(() => {
    if (scrollToBottom) {
      scrollToBottom();
    }
  }, []);

  return (
    <div>
      <h2 style={{ color: foregroundColor }}>{data.title}</h2>
      <div style={tableStyle}>
        <table style={tableStyle}>
          <thead>
            <tr>
              {data.headers.map((headerText, idx) => (
                <th key={idx} style={headerStyle}>
                  {headerText}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.rows.map((row, idx) => {
              const rowBackground = rowAlternateColor
                ? alternateRowColors[idx % alternateRowColors.length]
                : backgroundColor;

              return (
                <tr key={idx} style={{ backgroundColor: rowBackground }}>
                  {data.headers.map((header, colIdx) => (
                    <td key={colIdx} style={cellStyle}>
                      {row[header]}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default TableNew;
